define(['jquery', 'bing', 'c21/maps', 'c21/internationalization'], function ($, BingMaps, C21Maps, C21I18n) {
   "use strict";

   var self = {},
      mMap = null,
      dDirectionsManager = null;

   function renderCanvasPin(text, image) {
      var c = document.createElement('canvas'),
         ctx = c.getContext('2d'),
         font = "700 10pt Arial, Helvetica, sans-serif";

      var width = 28;
      var height = 32;

      c.width = width;
      c.height = height;

      ctx.drawImage(image, 0, 0);

      ctx.font = font;
      ctx.fillStyle = '#000';
      ctx.fillText(text, (width - ctx.measureText(text).width) / 2, 17);

      return c;
   }

   function initializeMap() {
      var jHolder = $('.locationsMap'),
          locHolder = $('.mainOffice'),
          location;

      if (mMap !== null && !jHolder.hasClass('hasMap')) {
         mMap = null;
      }
      if (mMap === null && jHolder.is(":visible")) {
         jHolder.addClass('hasMap');
         location = new BingMaps.Location(locHolder.data("latitude"), locHolder.data("longitude"));

         var opts = {
            credentials: C21Maps.bingmapCredentials,
            center: location,
            showDashboard: false,
            mapTypeId: BingMaps.MapTypeId.auto,
            customizeOverlays: true,
            enableSearchLogo: false,
            disableUserInput: true
         };

         var locs = [ location ];

         $('.officeCard').each(function () {
            locs.push(new BingMaps.Location($(this).data("latitude"), $(this).data("longitude")));
         });

         if (locs.length === 0) {
            opts.zoom = 13;
         } else {
            opts.bounds = BingMaps.LocationRect.fromLocations(locs);
         }

         mMap = new BingMaps.Map(jHolder.get(0), opts);

         var imgBranchOffice = new Image();
         imgBranchOffice.onload = function () {
            for (var loc in locs) {
               if(parseInt(loc) !== 0) {
                   var text = parseInt(loc).toString();
                   mMap.entities.push(new BingMaps.Pushpin(locs[loc], {
                       icon: renderCanvasPin(text, imgBranchOffice).toDataURL(),
                       width: 28,
                       height: 32,
                   }));
               }
            }
         };
         imgBranchOffice.src = "/images/eco/icons/pushpins/branch_office.png";

         mMap.entities.push(new BingMaps.Pushpin(location, {
            icon: "/images/eco/icons/pushpins/main_office.png",
            width: 47,
            height: 54
         }));

         BingMaps.loadModule('Microsoft.Maps.Directions', { callback: initializeDirections });
      }
   }

   function initializeDirections() {
      var jItinerary = $('#itineraryContainer');
      dDirectionsManager = new BingMaps.Directions.DirectionsManager(mMap);

      BingMaps.Events.addHandler(dDirectionsManager, 'directionsError', function (e) {
         $('#itineraryContainer').empty().append('<h3>' + e.message + '</h3>');
      });

      $('.drivingDirections').on('submit', 'form', function (e) {
         e.preventDefault();
         dDirectionsManager.clearAll();
         jItinerary.empty();

         dDirectionsManager.setRenderOptions({
            itineraryContainer: jItinerary.get(0),
         });

         var wFromLocation = new BingMaps.Directions.Waypoint({
            address: $('#fromLocation', this).val()
         });
         var wToLocation = new BingMaps.Directions.Waypoint({
            address: $('#toLocation', this).val()
         });

         dDirectionsManager.addWaypoint(wFromLocation);
         dDirectionsManager.addWaypoint(wToLocation);
         dDirectionsManager.calculateDirections();
      });
   }

   function initializeViewMore() {
      $('.serviceAreasList').on('click', 'a.viewMore', function (e) {
         e.preventDefault();
         $('.serviceArea.hide').addClass('show').removeClass('hide');
         $(this).hide();
         $(this).siblings('a.viewLess').show();
      });

      $('.serviceAreasList').on('click', 'a.viewLess', function (e) {
         e.preventDefault();
         $('.serviceArea.show').addClass('hide').removeClass('show');
         $(this).hide();
         $(this).siblings('a.viewMore').show();
      });
   }

   self.initialize = function() {
      $(window).on('resize', initializeMap);
      initializeMap();
      initializeViewMore();
   };

   return self;
});